import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { usersService } from './_deps';

export const fetchUsers = createAsyncThunk<void, void, { state: RootState }>(
  'users/fetch',
  async (_, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    const res = await usersService.listUsers();
    dispatch(entitiesActions.setUsers(res.items));
  },
);
